import { combineReducers } from 'redux';
import { modals } from 'controls/modals/reducer';
import { siteInfoInfoReducer } from './siteInfo';
import { userInfoReducer } from './userInfo';

export const rootReducer = combineReducers({
  modals,
  siteInfo: siteInfoInfoReducer,
  userInfo: userInfoReducer,
});
